import React from 'react';
import { Feature, useFeatureToggle } from '@members/feature-toggles';
import { LocationPrivacyRedirect } from './LocationPrivacyRedirect';

export const LocationPrivacyCheck: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isLocationPrivacyUpdateEnabled = useFeatureToggle(Feature.FreeSnowDen);

  return isLocationPrivacyUpdateEnabled ? <LocationPrivacyRedirect /> : null;
};
